import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import ScrollReveal from '@/components/base/ScrollReveal';

const PROCESS_STEPS = [
  { step: '01', icon: 'ri-search-eye-line', titleKey: 'process1Title', descKey: 'process1Desc' },
  { step: '02', icon: 'ri-settings-4-line', titleKey: 'process2Title', descKey: 'process2Desc' },
  { step: '03', icon: 'ri-brush-3-line', titleKey: 'process3Title', descKey: 'process3Desc' },
  { step: '04', icon: 'ri-rocket-line', titleKey: 'process4Title', descKey: 'process4Desc' },
  { step: '05', icon: 'ri-bar-chart-grouped-line', titleKey: 'process5Title', descKey: 'process5Desc' },
];

export default function Process() {
  const { t } = useTranslation();

  return (
    <section className="py-20 md:py-28 bg-[#F7F8FA]">
      <div className="max-w-5xl mx-auto px-6 md:px-10">
        <ScrollReveal>
          <div className="text-center mb-16">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-50 text-primary-700 text-xs font-semibold tracking-wider uppercase mb-4">
              {t('trafficPro.processTag')}
            </span>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950">
              {t('trafficPro.processTitle')}{' '}
              <span className="text-primary-500">{t('trafficPro.processTitleHighlight')}</span>
            </h2>
          </div>
        </ScrollReveal>

        <div className="relative">
          <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-px bg-gray-200 -translate-x-1/2"></div>

          <div className="space-y-0">
            {PROCESS_STEPS.map((s, i) => (
              <ScrollReveal key={s.step} delay={i * 0.12}>
                <div className={`relative flex flex-col md:flex-row items-start md:items-center gap-6 md:gap-12 pb-14 md:pb-16 last:pb-0 ${i % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'}`}>
                  <div className={`flex-1 ${i % 2 === 0 ? 'md:text-right' : 'md:text-left'} ${i % 2 === 0 ? 'md:pr-12' : 'md:pl-12'}`}>
                    <span className="font-heading text-5xl md:text-6xl font-bold text-primary-100 leading-none select-none">
                      {s.step}
                    </span>
                    <h3 className="font-heading text-xl font-bold text-foreground-950 mt-2 mb-2">
                      {t(`trafficPro.${s.titleKey}`)}
                    </h3>
                    <p className="text-foreground-600 text-sm leading-relaxed">
                      {t(`trafficPro.${s.descKey}`)}
                    </p>
                  </div>

                  <div className="relative z-10 flex-shrink-0">
                    <div className="w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-white border border-gray-100 shadow-[0_2px_12px_rgba(0,0,0,0.04)] flex items-center justify-center">
                      <i className={`${s.icon} text-primary-500 text-2xl`}></i>
                    </div>
                  </div>

                  <div className={`flex-1 hidden md:block`}></div>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}